import {requestApi} from "../../utils/utils";
import {
    GET_TRIP_BY_ID_FAIL,
    GET_TRIP_BY_ID_REQUEST,
    GET_TRIP_BY_ID_SUCCESS, SET_BOOKING_TYPE,
    SET_TRIP_ROOMS
} from "../constants/tripConstants";
import {SET_PARK_FEE, SET_PORT_FEE, SET_TAX} from "../constants/totalConstants";
import {setTotals} from "./totalActions";


export const getTripById = (id) => async (dispatch) => {
    dispatch({type: GET_TRIP_BY_ID_REQUEST});

    try {
        const {data: {data: { trip, rooms, parkfee, portFee, tax }}} = await requestApi(`/get-trip/${id}`);

        dispatch({type: GET_TRIP_BY_ID_SUCCESS, payload: trip});
        dispatch({type: SET_TRIP_ROOMS, payload: rooms});
        dispatch({type: SET_PARK_FEE, payload: {...parkfee, perDay: parseFloat(parkfee.perDay)}});
        dispatch({type: SET_PORT_FEE, payload: {...portFee, feeAmount: parseFloat(portFee.feeAmount)}});
        dispatch({type: SET_TAX, payload: parseFloat(tax)});

        dispatch(setTotals());
    } catch (e) {
        dispatch({type: GET_TRIP_BY_ID_FAIL, error: e});
    }

};

export const setBookingType = (type = 'pay') => (dispatch) => {
    sessionStorage.setItem('bookingType', type);
    dispatch({type: SET_BOOKING_TYPE, payload: type});
};